export const getFileNaming = (formData: any): string | undefined => {
  const { stage, variant, adChannel } = formData;

  if (!stage || !variant || !adChannel) return undefined;

  const channelCapitalized = adChannel.charAt(0).toUpperCase() + adChannel.slice(1);

  return `${stage}_Mot_${variant}_${channelCapitalized}`;
};
